import React, { useState, useCallback } from 'react';
import { Transition } from '@headlessui/react';

function IntegerField(props) {
  // Handle both direct props and remount attribute props
  const setting = props.setting
  const initialValue = props.initialValue || props['initial-value'] || '0'
  const min = props.min || null
  const max = props.max || null
  const onSave = props.onSave
  
  // Parse initialValue if it's a string
  const parsedInitialValue = typeof initialValue === 'string' ? parseInt(initialValue, 10) : initialValue;
  const [value, setValue] = useState(parsedInitialValue);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    setSuccess(false);

    try {
      // Build the full URL to ensure it works with admin subdomain
      const baseUrl = window.location.origin;
      const response = await fetch(`${baseUrl}/settings/${setting}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        },
        body: JSON.stringify({ value: value, field_type: 'integer' })
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
        setTimeout(() => setSuccess(false), 3000);
        if (onSave) onSave(value);
      } else {
        setError(data.error || 'Failed to save setting');
      }
    } catch (e) {
      setError('Network error: ' + e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    if (!isNaN(newValue)) {
      setValue(newValue);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <input
          type="number"
          value={value}
          onChange={handleChange}
          min={min}
          max={max}
          className="input input-bordered w-32 dark:bg-gray-700 dark:text-white"
        />
        <button
          type="button"
          onClick={handleSave}
          disabled={saving}
          className="btn btn-primary btn-sm"
        >
          {saving ? (
            <>
              <span className="loading loading-spinner loading-xs"></span>
              Saving...
            </>
          ) : (
            'Save Changes'
          )}
        </button>
        <Transition
          show={success}
          enter="transition-opacity duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <span className="text-sm text-success">✓ Saved successfully</span>
        </Transition>
      </div>

      <Transition
        show={!!error}
        enter="transition-opacity duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="text-sm text-error">{error}</div>
      </Transition>
    </div>
  );
}

export default IntegerField;